import React from 'react';

export default function InternalBacklinksPanel({ backlinks = [], onNavigate }) {
  if (!Array.isArray(backlinks) || backlinks.length === 0) return null;

  return (
    <div className="internal-backlinks-panel">
      <p className="internal-backlinks-title">
        Linked from ({backlinks.length})
      </p>
      <div className="internal-backlinks-list">
        {backlinks.map((item) => (
          <button
            type="button"
            key={`${item.sourceType}:${item.sourceId}`}
            className="internal-backlinks-item"
            onClick={() => onNavigate?.(item)}
          >
            <span className="internal-backlinks-item-title">{item.sourceTitle}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
